import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App.tsx';
import { envResult } from './lib/env.ts';
import { initSentry } from './lib/sentry.ts';
import './index.css';

if (envResult.ok) initSentry(envResult.env);

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
